import React from "react";
import Header from "./Header";
import LocationDetails from "./LocationDetails";
import "../css/Menu.css";
import useSanityPage from "../lib/useSanityPage";

export default function Menu() {
  const { page } = useSanityPage("maynooth-menu", "maynooth")

  const pdfResources = page?.pdfs?.length
    ? page.pdfs
    : [
        {
          title: "Lunch Menu",
          description:
            "Freshly made soup, salads, sandwiches & more, and maybe a glass of wine too.",
          buttonText: "See Lunch Menu →",
          file: { asset: { url: "/lunch_menu.pdf" } },
          openInNewTab: true,
        },
        {
          title: "Evening Menu",
          description:
            "Think small plates, sharing & grazing, cheese & charcuterie, seafood & steaks and of course great wines by the glass.",
          buttonText: "See Evening Menu →",
          file: { asset: { url: "/dinner_menu.pdf" } },
          openInNewTab: true,
        },
        {
          title: "Christmas Lunch Menu",
          description:
            "A festive lunch filled with seasonal favourites, delicious sharing plates, and a little Christmas cheer.",
          buttonText: "See Evening Menu →",
          file: { asset: { url: "/christmas_lunch.pdf" } },
          openInNewTab: true,
        },
        {
          title: "Christmas Dinner Menu",
          description:
            "Celebrate the season with a festive evening of delicious food, sharing plates, fine wines and plenty of Christmas spirit.",
          buttonText: "See Evening Menu →",
          file: { asset: { url: "/christmas_dinner.pdf" } },
          openInNewTab: true,
        },
        {
          title: "ELY Late Night Plates",
          description:
            "Late-night food on Friday and Saturday nights until 10:30pm!",
          buttonText: "See Late Night Plates →",
          file: { asset: { url: "/late_night_bites.pdf" } },
          openInNewTab: true,
        }
      ]

  return (
    <>
      <Header />
      <section className="menu">
        <h1 className="menu_title">{page?.title || "Our Menus"}</h1>
        <p className="menu-description">
          {page?.sections?.[0]?.body || ""}
        </p>

        <div className="menu-card-container">
          {pdfResources.map((resource, index) => (
            <React.Fragment key={`${resource.title}-${index}`}>
              {index > 0 ? <div className="menu-divider" /> : null}
              <div className="menu-card">
                <h2 className="menu-card-title">{resource.title}</h2>
                {resource.description ? (
                  <p className="menu-card-text">{resource.description}</p>
                ) : null}
                <a
                  href={resource.file?.asset?.url || "#"}
                  className="menu-card-link"
                  target={resource.openInNewTab ? "_blank" : "_self"}
                  rel={resource.openInNewTab ? "noreferrer" : undefined}
                >
                  {resource.buttonText || "View PDF →"}
                </a>
              </div>
            </React.Fragment>
          ))}
        </div>
      </section>
      <LocationDetails />
    </>
  );
}
